import { render, staticRenderFns } from "./cariregisternasabah.vue?vue&type=template&id=194040b8"
import script from "./cariregisternasabah.vue?vue&type=script&lang=js"
export * from "./cariregisternasabah.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports